import * as React from "react";
import Panel from "../../Panel";
import ResetPasswordForm from "./ResetPasswordForm";

export default function ResetPassword() {
  return (
    <Panel>
      <ResetPasswordForm />
    </Panel>
  );
}
